import Vue from 'vue'
import ElementUI from 'element-ui'
import '@/assets/element-variables.scss'; // 引入自定义主题
import App from './App.vue'
import router from './router'

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')